import { call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_INVESTOR_INVESTMENTS,
  SET_INVESTOR_INVESTMENTS,
  GET_INVESTOR_INVESTMENT_DETAIL,
  SET_INVESTOR_INVESTMENT_DETAIL,
  SEND_INVESTOR_INSTRUCTION,
  SELL_INVESTOR_INVESTMENT_TO_GUARANTEE_FUND,
  CREATE_INVESTOR_INVESTMENT_OFFER,
  SET_INVESTOR_OFFERS,
  GET_INVESTOR_OFFERS,
  CANCEL_INVESTOR_INVESTMENT_OFFER,
  SET_INVESTOR_INVESTMENT_INSTRUCTION,
  GET_INVESTOR_INVESTMENT_INSTRUCTION,
  SET_INVESTOR_SECONDARY_MARKET,
  GET_INVESTOR_SECONDARY_MARKET,
  BUY_OFFER_FROM_SECONDARY_MARKET,
  GET_INVESTOR_DASHBOARD_DATA,
  BID_OFFER_FROM_SECONDARY_MARKET,
  SET_INVESTOR_BIDDINGS,
  GET_INVESTOR_BIDDINGS,
  ACCEPT_BIDDING,
  DECLINE_BIDDING,
  GET_INVESTMENTS_FOR_SALE,
  SET_INVESTMENTS_FOR_SALE,
  POST_INVESTMENTS_FOR_SALE,
  GET_RESOURCES_REQUEST,
  GET_INVESTOR_OFFERS_COUNT,
  GET_INVESTOR_OFFERS_ERROR,
  TRANSFER_CLAIM,
} from '../redux/action/types';
import {
  setGlobalErrorVisibility,
  getUserResourcesSuccess,
  setInvestorOffersCount,
  getInvestorOffersCountError,
} from '../redux/action';
import { areaApi } from '../utils/api';

function* getInvestorInvestments(action) {
  try {
    const investments = yield areaApi.getInvestorInvestments(action.data.data);
    yield put({
      type: SET_INVESTOR_INVESTMENTS,
      data: investments.data.data,
      payload: investments.data.meta,
    });
    if (investments.status === 200) {
      action.data.onSuccess();
    }
  } catch (err) {
    action.data.onBadResponse();
    console.log(err);
  }
}

function* getInvestorOffers(action) {
  try {
    const offers = yield areaApi.getInvestorInvestments(action.data.data);

    const data = { items: offers.data.data, pagination: offers.data.meta };

    yield put({
      type: SET_INVESTOR_OFFERS,
      payload:
        action.data.data.type === 'offered-manual'
          ? { manualOffers: data, manualLoading: false }
          : { automaticOffers: data, automaticLoading: false },
    });

    if (offers.status === 200) {
      action.data.onSuccess();
    }
  } catch (err) {
    yield put({
      type: GET_INVESTOR_OFFERS_ERROR,
      ...(action.data.data.type === 'offered-manual'
        ? { manualLoading: false }
        : { automaticLoading: false }),
    });
    action.data.onBadResponse();
    console.log(err);
  }
}

function* getInvestorBiddings(action) {
  try {
    const biddings = yield call(() => areaApi.getInvestorBiddings(action.data.data));
    yield put({
      type: SET_INVESTOR_BIDDINGS,
      data: biddings.data.data,
      payload: biddings.data.meta,
    });
    if (biddings.status === 200) {
      action.data.onSuccess && action.data.onSuccess();
    }
  } catch (err) {
    action.data.onBadResponse && action.data.onBadResponse();
    console.log(err);
  }
}

function* getInvestorInvestmentInstruction() {
  try {
    const instruction = yield areaApi.getInvestorInvestmentInstruction();
    yield put({
      type: SET_INVESTOR_INVESTMENT_INSTRUCTION,
      data: instruction.data,
    });
  } catch (err) {
    console.log(err);
  }
}

function* getInvestorSecondaryMarket(action) {
  try {
    const secondayMarket = yield areaApi.getInvestorSecondaryMarket(action.data.data);
    yield put({
      type: SET_INVESTOR_SECONDARY_MARKET,
      data: secondayMarket.data.data,
      payload: secondayMarket.data.meta,
    });
    if (secondayMarket.status === 200) {
      action.data.onSuccess && action.data.onSuccess();
    }
  } catch (err) {
    action.data.onBadResponse && action.data.onBadResponse();
    console.log(err);
  }
}

function* getInvestorInvestmentDetail(action) {
  try {
    const detail = yield areaApi.getInvestorInvestmentDetail(action.data.id, action.data.offerId);
    yield put({
      type: SET_INVESTOR_INVESTMENT_DETAIL,
      data: detail.data,
    });
  } catch (err) {
    action.data.onBadId();
    console.log(err);
  }
}

function* sellInvestmentToGuaranteeFund(action) {
  try {
    let response = yield call(() =>
      areaApi.sellInvestmentToGuaranteeFund(action.data.data, action.data.investment)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* createInvestmentOffer(action) {
  try {
    let response = yield call(() =>
      areaApi.createInvestmentOffer(action.data.data, action.data.investment)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });

      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* cancelOfferSell(action) {
  try {
    let response = yield call(() => areaApi.cancelOfferSell(action.data.data, action.data.offer));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* buySecondaryMarketOffer(action) {
  try {
    let response = yield call(() =>
      areaApi.buySecondaryMarketOffer(action.data.data, action.data.offer)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else if (err && err.status === 400 && err.data?.error_code === 'OFFER_CLOSED') {
      action.data.onOfferClosedError && action.data.onOfferClosedError();
    } else if (err && err.status === 400 && err.data?.error_code === 'NOT_ENOUGH_FREE_RESOURCES') {
      action.data.onResourcesError && action.data.onResourcesError();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* acceptBiddingOffer(action) {
  try {
    let response = yield call(() =>
      areaApi.acceptBiddingOffer(action.data.data, action.data.bidding)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode && action.data.onBadSmsCode();
    } else if (err && err.status === 400 && err.data?.error_code === 'BIDDING_CLOSED') {
      action.data.onBiddingError && action.data.onBiddingError(err.data?.error_code);
    } else if (err && err.status === 400 && err.data?.error_code === 'NOT_ENOUGH_FREE_RESOURCES') {
      action.data.onResourcesError && action.data.onResourcesError();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* declineBiddingOffer(action) {
  try {
    let response = yield call(() =>
      areaApi.declineBiddingOffer(action.data.data, action.data.bidding)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode && action.data.onBadSmsCode();
    } else if (err && err.status === 400 && err.data?.error_code === 'BIDDING_CLOSED') {
      action.data.onBiddingError && action.data.onBiddingError(err.data?.error_code);
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* bidSecondaryMarketOffer(action) {
  try {
    let response = yield call(() =>
      areaApi.bidSecondaryMarketOffer(action.data.data, action.data.offer, action.data.biddingId)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else if (
      err &&
      err.status === 400 &&
      (err.data?.error_code === 'OFFER_CLOSED' ||
        err.data?.error_code === 'BIDDING_CLOSED' ||
        err.data?.error_code === 'NOT_YOUR_TURN' ||
        err.data?.error_code === 'NOT_ENOUGH_FREE_RESOURCES')
    ) {
      action.data.onOfferError && action.data.onOfferError(err.data?.error_code);
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* sendInvestorInstruction(action) {
  try {
    let response = yield call(() => areaApi.sendInvestorInstruction(action.data.data));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: GET_INVESTOR_DASHBOARD_DATA,
      });
      yield put({
        type: GET_INVESTOR_INVESTMENT_INSTRUCTION,
      });
      action.data.onSuccess();
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* getInvestmentsForSale(action) {
  try {
    let response = yield call(() => areaApi.getInvestmentsForSale(action.payload));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: SET_INVESTMENTS_FOR_SALE,
        payload: response.data.data,
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function* postInvestmentsForSale(action) {
  try {
    let response = yield call(() => areaApi.postInvestmentsForSale(action.payload));
    if ((response && response.status === 200) || (response && response.status === 201)) {
      yield put({
        type: SET_INVESTMENTS_FOR_SALE,
        payload: response.data.data,
      });
    }
    action.onSuccess();
  } catch (err) {
    if (err && err.status === 403) {
      action.onBadSmsCode();
    } else if (err && err.status === 400) {
      action.onError();
    } else {
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* getResourcesRequest() {
  try {
    const response = yield call(areaApi.getInvestmentsOverview);
    yield put(getUserResourcesSuccess(response.data));
  } catch (error) {
    console.log('getResourcesRequest error', error);
  }
}

function* getOffersCount() {
  try {
    const request = {
      type: 'offered-automatic',
      page: 1,
      per_page: 1,
    };

    const automatic = yield areaApi.getInvestorInvestments(request);
    const manual = yield areaApi.getInvestorInvestments({
      ...request,
      type: 'offered-manual',
    });

    yield put(
      setInvestorOffersCount({
        automatic: automatic.data.meta.total,
        manual: manual.data.meta.total,
      })
    );
  } catch (error) {
    yield put(getInvestorOffersCountError());
    console.log('getOffersCount error', error);
  }
}

function* transferClaim(action) {
  try {
    let response = yield call(() =>
      areaApi.transferClaim(action.data.data, action.data.investmentId)
    );
    if ((response && response.status === 200) || (response && response.status === 201)) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    if (err && err.status === 403) {
      action.data.onBadSmsCode();
    } else {
      action.data.onError && action.data.onError();
      yield put(setGlobalErrorVisibility(true));
      console.log(err);
    }
  }
}

function* investmentsSaga() {
  yield takeLatest(GET_INVESTOR_SECONDARY_MARKET, getInvestorSecondaryMarket);
  yield takeLatest(GET_INVESTOR_INVESTMENTS, getInvestorInvestments);
  yield takeLatest(GET_INVESTOR_OFFERS, getInvestorOffers);
  yield takeLatest(GET_INVESTOR_INVESTMENT_DETAIL, getInvestorInvestmentDetail);
  yield takeLatest(GET_INVESTOR_INVESTMENT_INSTRUCTION, getInvestorInvestmentInstruction);
  yield takeLatest(CANCEL_INVESTOR_INVESTMENT_OFFER, cancelOfferSell);
  yield takeLatest(CREATE_INVESTOR_INVESTMENT_OFFER, createInvestmentOffer);
  yield takeLatest(SELL_INVESTOR_INVESTMENT_TO_GUARANTEE_FUND, sellInvestmentToGuaranteeFund);
  yield takeLatest(SEND_INVESTOR_INSTRUCTION, sendInvestorInstruction);
  yield takeLatest(BUY_OFFER_FROM_SECONDARY_MARKET, buySecondaryMarketOffer);
  yield takeLatest(BID_OFFER_FROM_SECONDARY_MARKET, bidSecondaryMarketOffer);
  yield takeLatest(GET_INVESTOR_BIDDINGS, getInvestorBiddings);
  yield takeLatest(ACCEPT_BIDDING, acceptBiddingOffer);
  yield takeLatest(DECLINE_BIDDING, declineBiddingOffer);
  yield takeLatest(GET_INVESTMENTS_FOR_SALE, getInvestmentsForSale);
  yield takeLatest(POST_INVESTMENTS_FOR_SALE, postInvestmentsForSale);
  yield takeLatest(GET_RESOURCES_REQUEST, getResourcesRequest);
  yield takeLatest(GET_INVESTOR_OFFERS_COUNT, getOffersCount);
  yield takeLatest(TRANSFER_CLAIM, transferClaim);
}

export default investmentsSaga;
